import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowTurnUpRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0942 2.66669C11.2628 3.53089 12.3123 4.54045 13.2169 5.66984C13.2945 5.76673 13.3333 5.88337 13.3333 6.00002M10.0942 9.33335C11.2628 8.46915 12.3123 7.45959 13.2169 6.3302C13.2945 6.23331 13.3333 6.11667 13.3333 6.00002M13.3333 6.00002H8C6.13316 6.00002 5.19974 6.00002 4.4867 6.36333C3.85949 6.68291 3.34956 7.19284 3.02998 7.82005C2.66667 8.53309 2.66667 9.46651 2.66667 11.3334V13.3334",
		stroke: "#2563EB",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgArrowTurnUpRight);
export default ForwardRef;
